<!--
 * @FileDescription: 横向排列4级区域(省市区县镇)选择框
 * 传入参数 title 选择框标题
 * 传出参数 outAreas 区域ID对象{provId,cityId,distId,townId}
 * @Author: XuYao
 * @Date: 2020-04-27 23:10:02
 * @LastEditors: XuYao
 * @LastEditTime: 2020-04-27 23:10:02
-->
<template>
    <div style="width: 100%;" class="yx-flex-h-start">

        <el-select v-model="cnaps.bankCode" clearable :filterable="filterable" @change="bankChanged" placeholder="开户银行" size="small" style="width: 20%;">
            <el-option
                    v-for="item in bankList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
            </el-option>
        </el-select>
        <div style="width: 0.5%"/>
        <el-select v-model="cnaps.provCode" clearable :filterable="filterable" @change="provChanged" placeholder="开户省份" size="small" style="width: 20%;">
            <el-option
                    v-for="item in provList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
            </el-option>
        </el-select>
        <div style="width: 0.5%"/>
        <el-select v-model="cnaps.cityCode" clearable :filterable="filterable" @change="cityChanged" placeholder="开户城市" size="small" style="width: 20%;">
            <el-option
                    v-for="item in cityList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
            </el-option>
        </el-select>
        <div style="width: 0.5%"/>
        <el-select v-model="cnaps.cnapsCode" filterable clearable @change="cnapsChanged" placeholder="联行/支行名称" size="small" style="width: 38.5%;">
            <el-option
                    v-for="item in cnapsList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
            </el-option>
        </el-select>

    </div>
</template>

<script>
    import {
        URL_BANK_BANK_LIST,
        URL_BANK_CITY_LIST,
        URL_BANK_CNAPS,
        URL_BANK_CNAPS_LIST,
        URL_BANK_PROV_LIST
    } from "../../utils/cons";

    export default {
        name: "BankSelect",
        data() {
            return {
                outCnapsCode: null,
                bankList:[],
                provList:[],
                cityList:[],
                cnapsList:[],
                cnaps:{
                    cnapsCode:null,
                    cnapsName:null,
                    bankCode:null,
                    bankName:null,
                    provCode:null,
                    provName:null,
                    cityCode:null,
                    cityName:null
                }
            }
        },
        props: {
            filterable: {
                type: Boolean,
                default: false
            },
            inCnapsCode: {
                type: String,
                default: null
            }
        },
        mounted() {
            this.cnaps.cnapsCode = this.inCnapsCode;
            this.loadCnapsInfo();
        },
        methods: {
            emitToParent() {
                this.outCnapsCode = this.cnaps.cnapsCode;
                this.$emit('onCnapsChanged', this.cnaps);
                this.$emit('update:outCnapsCode', this.outCnapsCode);
            },
            cnapsChanged() {
                this.emitToParent();
            },
            provChanged() {
                this.cityList = [];
                this.cnapsList = [];
                this.cnaps.cnapsCode = '';
                this.cnaps.cnapsName = '';
                this.cnaps.cityCode = '';
                this.cnaps.cityName = '';

                this.cnapsChanged();

                this.loadCityList();
            },
            cityChanged() {
                this.cnapsList = [];
                this.cnaps.cnapsCode = '';
                this.cnaps.cnapsName = '';

                this.cnapsChanged();

                this.loadCnapsList();
            },
            bankChanged() {
                this.cnapsList = [];
                this.cnaps.cnapsCode = '';
                this.cnaps.cnapsName = '';

                this.cnapsChanged();

                this.loadCnapsList();
            },
            loadBankList() {
                this.getRequest(URL_BANK_BANK_LIST).then(resp => { if (resp) this.bankList = resp.data });
            },
            loadProvList() {
                this.getRequest(URL_BANK_PROV_LIST).then(resp => { if (resp) this.provList = resp.data });
            },
            loadCityList() {
                if(this.cnaps.provCode)
                    this.getRequest(URL_BANK_CITY_LIST + '?provCode=' + this.cnaps.provCode).then(resp => { if (resp) this.cityList = resp.data });
            },
            loadCnapsList() {
                if(this.cnaps.cityCode && this.cnaps.bankCode)
                    this.getRequest(URL_BANK_CNAPS_LIST + '?cityCode=' + this.cnaps.cityCode + '&bankCode=' + this.cnaps.bankCode).then(resp => { if (resp) this.cnapsList = resp.data });
            },
            loadCnapsInfo() {
                if(this.cnaps.cnapsCode) {
                    this.getRequest(URL_BANK_CNAPS + '?cnapsCode=' + this.cnaps.cnapsCode).then(resp =>
                    {
                        if (resp) {
                            if(resp.data[0]) {
                                this.cnaps = resp.data[0];
                                this.bankList.push({"code":this.cnaps.bankCode,"name":this.cnaps.bankName});
                                this.provList.push({"code":this.cnaps.provCode,"name":this.cnaps.provName});
                                this.cityList.push({"code":this.cnaps.cityCode,"name":this.cnaps.cityName});
                                this.cnapsList.push({"code":this.cnaps.cnapsCode,"name":this.cnaps.cnapsName});
                            }
                            this.loadBankList();
                            this.loadProvList();
                            this.loadCityList();
                            this.loadCnapsList();
                        }
                    });
                }
                else {
                    this.loadBankList();
                    this.loadProvList();
                }

            }
        }
    }
</script>

<style scoped>

</style>
